import React, { Fragment, useEffect } from "react";
import Button from "../Button/Button";

const ModalConfirm = ({ deactive, onCancel, product_status, confirm }) => {
  const color = !deactive ? "#cf4e4e" : "#047408";

  useEffect(() => {
    const overlay = document.querySelector(".modal-overlay");
    const listener = (event) => {
      if (overlay) {
        onCancel();
      }
    };
    overlay.addEventListener("click", listener);
  });

  return (
    <Fragment>
      <div
        style={{ zIndex: "1000000" }}
        className="fixed inset-0 overflow-y-auto "
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          className="flex items-center  min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 transition-opacity ease-in duration-300"
          style={{ transition: "opacity 0.25s ease" }}
        >
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-50  modal-overlay"
            aria-hidden="true"
          ></div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <div className="inline-block bg-white rounded-2xl overflow-hidden shadow-xl transform transition-all sm:my-8 align-middle sm:max-w-2xl w-full">
            <div className="bg-white py-9">
              <div className="max-w-xl mx-auto w-full p-3 md:p-0">
                <img
                  className="m-2 absolute left-4 top-4"
                  src="/statics/images/close.svg"
                  width="16px"
                  height="16px"
                  alt="arrow"
                  onClick={() => {
                    onCancel();
                  }}
                />

                <>
                  {!deactive ? (
                    <div className="color-red mb-10">
                      آیا از عدم تایید این آگهی مطمئن هستید؟
                    </div>
                  ) : (
                    <div className="color-green mb-10">
                      آیا از تایید کردن این آگهی مطمئن هستید؟
                    </div>
                  )}

                  <img
                    className="my-10 mx-auto"
                    src={
                      !deactive
                        ? "/statics/images/confirmtick-red.svg"
                        : "/statics/images/confirmtick-green.svg"
                    }
                    alt="arrow"
                  />

                  <div className="flex justify-center items-center gap-4">
                    <Button
                      title="بله"
                      backgroundColor={color}
                      borderColor={color}
                      color="#fff"
                      borderWidth="2px"
                      margin="0"
                      maxHeight="40px"
                      maxWidth="150px"
                      onClick={() => {
                        confirm();
                        onCancel();
                      }}
                    />
                    <Button
                      title="خیر"
                      margin="0"
                      backgroundColor="#fff"
                      borderColor={color}
                      color={color}
                      maxWidth="150px"
                      maxHeight="40px"
                      onClick={() => {
                        onCancel();
                      }}
                    />
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModalConfirm;
